module.exports = __webpack_public_path__ + "img/collection-memoireRingsGold@2x.031ca9a.jpg";